// extracted by mini-css-extract-plugin
export var dataCell = "_mx-2";
export var dataRow = "_mx-0";
export var headerRow = "_mx-1";